{
  "app": {
    "title": "Sculpt Agent",
    "loading": "Loading…",
    "notExcel": "Open this add-in inside Excel Desktop to chat with Sculpt Agent.",
    "sessionExpired": "Your session has expired. Please sign in again.",
    "selfTestMissing": "Self-test harness is not present in this build.",
    "byline": "by Peerception"
  },
  "login": {
    "title": "Sign in",
    "subtitle": "Use your Sculpt Agent account to chat with the assistant about this workbook.",
    "email": "Email",
    "emailPlaceholder": "you@example.com",
    "password": "Password",
    "passwordPlaceholder": "Enter your password",
    "show": "show",
    "hide": "hide",
    "continue": "Sign in",
    "submitting": "Signing in…",
    "error": "Invalid email or password.",
    "rateLimited": "Too many sign-in attempts. Wait 15 minutes, or continue with Microsoft.",
    "microsoft": "Continue with Microsoft",
    "microsoftBusy": "Waiting for Microsoft…",
    "or": "or",
    "sso": {
      "cancelled": "Sign-in cancelled.",
      "signup_disabled": "Your Microsoft account is not registered on Sculpt Agent yet. Ask your administrator for an invitation.",
      "sso_failed": "Microsoft sign-in failed. Please try again.",
      "origin_not_allowed": "This add-in origin is not allowed to sign in with Microsoft (API setting SCULPT_OAUTH_ORIGINS).",
      "unsupported": "Microsoft sign-in needs the Office dialog, which this Excel version does not provide. Use your email and password.",
      "timeout": "Microsoft sign-in timed out.",
      "dialog_error": "The sign-in window could not be opened.",
      "bad_message": "Unexpected reply from the sign-in window.",
      "account_disabled": "This account is disabled. Contact the Sculpt Agent team.",
      "email_plus_address": "This Microsoft account uses an address with a “+…” part, which cannot open a Sculpt Agent account. Sign in with your own address.",
      "email_disposable_domain": "This Microsoft account uses a disposable or temporary email address, which cannot open a Sculpt Agent account. Sign in with your own address."
    },
    "success": "Signed in. Opening the assistant…",
    "noAccount": "No account yet?",
    "createAccount": "Create one",
    "forgot": "Forgot password?",
    "signupBusy": "Waiting for the signup…"
  },
  "legal": {
    "mention": "By continuing, you accept the <terms>Terms of sale</terms>, including the <dpa>Data Processing Agreement</dpa>. See our <privacy>Privacy policy</privacy>."
  },
  "header": {
    "history": "History",
    "newChat": "New chat",
    "logout": "Sign out",
    "language": "Language",
    "protect": "Protected sheets…",
    "converge": "Converge circular blocks",
    "report": "Report this conversation"
  },
  "mode": {
    "label": "Mode",
    "plan": "Plan",
    "ask": "Ask",
    "auto": "Auto",
    "full_auto": "Full auto",
    "planHint": "Read-only: the assistant proposes changes but cannot write.",
    "askHint": "Every write is staged for your approval before it runs.",
    "autoHint": "Writes run automatically; destructive actions still ask.",
    "full_autoHint": "Everything runs without confirmation. Use with care."
  },
  "welcome": {
    "greeting": "Welcome, {{name}}",
    "greetingAnon": "Welcome"
  },
  "chat": {
    "errorGeneric": "Something went wrong. Please try again.",
    "streamError": "The assistant was interrupted.",
    "thinking": "Thinking…",
    "workingExcel": "Working in Excel…",
    "readingModel": "Reading the model…",
    "planning": "Planning the change…",
    "writingProgress": "Writing in Excel · {{done}} of {{total}}",
    "writingProgressSheet": "Writing in Excel · {{done}} of {{total}} · {{sheet}}",
    "checkingWorkbook": "Checking the workbook…",
    "updatingIndex": "Reading your changes…",
    "indexFailed": "Your workbook could not be read ({{error}}). Send your message again.",
    "awaitingUnderstanding": "Understanding your changes…",
    "indexNotUnderstood": "Sculpt has not finished understanding your changes. Send your message again in a moment.",
    "turnsInProgress": "You already have {{limit}} replies running in other workbooks. Wait for one to finish, then send your message again.",
    "serviceInterrupted": "The assistant is temporarily unavailable. Our team is working on it: please try again later.",
    "selectInExcel": "Select {{address}} in Excel",
    "copyCode": "Copy",
    "copied": "Copied"
  },
  "composer": {
    "disclaimer": "Sculpt is an AI and can make mistakes. Check its changes.",
    "answering": "Answer here, or use the card above",
    "placeholder": "Ask anything…",
    "hint": "Enter ↵ · Shift+Enter newline",
    "working": "Working…",
    "send": "Send",
    "stop": "Stop",
    "spendTitle": "AI usage this period: spent / included",
    "trialOffer": "{{offer}} (trial)",
    "trialEnds": "trial ends {{date}}",
    "renews": "renews {{date}}",
    "credits": "{{amount}} of credits",
    "creditsLeft": "Credits · {{amount}} left",
    "usageLoading": "AI usage · …",
    "chooseOffer": "Choose an offer",
    "usage": "Usage",
    "freeTier": "Free tier",
    "orgPool": "organization {{spent}} / {{budget}}",
    "yourShare": "your share {{spent}} / {{cap}}",
    "openBilling": "Buy credits or change offer",
    "limit": {
      "legacy": "Usage limit reached. Contact Peerception to extend your allowance.",
      "limit_reached": "Your organization's included usage and credits are spent. An admin can buy credits or change offer.",
      "user_cap_reached": "You used your share of the included usage ({{cap}}). Credits or a larger offer lift it.",
      "member_cap_reached": "You reached the limit your admin set for you ({{cap}}).",
      "no_subscription": "Your organization has no active subscription.",
      "free_full": "Your organization has no subscription yet. An admin can choose an offer.",
      "trial_ended": "Your trial has ended. An admin can choose an offer to continue.",
      "payment_overdue": "Your organization's renewal is unpaid."
    },
    "upgrade": "Upgrade"
  },
  "skills": {
    "menu": "Skills — recipes for a whole task",
    "button": "Use a skill (/)"
  },
  "attachments": {
    "attach": "Attach a file (PDF, Word, PowerPoint, Excel, CSV, text, image)",
    "placeholder": "Ask about the attached file…",
    "uploading": "Uploading…",
    "remove": "Remove {{name}}",
    "pages_one": "{{count}} page",
    "pages_other": "{{count}} pages",
    "noText": "no readable text",
    "truncated": "long: read page by page",
    "errors": {
      "type": "Unsupported file type — PDF, Word (.docx), PowerPoint (.pptx), Excel, CSV, text or image.",
      "size": "File too large (20 MB max).",
      "count": "At most 5 files per message.",
      "upload": "Upload failed.",
      "ocr": "Could not transcribe the scanned pages."
    },
    "reading": "Reading scanned pages…",
    "ocr_one": "{{count}} page transcribed",
    "ocr_other": "{{count}} pages transcribed"
  },
  "context": {
    "selectionHint": "The selection is sent with your next messages as the pointer for \"this cell / here\". The assistant can still read and edit any sheet.",
    "addSelection": "Add the current selection to the context",
    "removeSelection": "Remove the selection from the context"
  },
  "approval": {
    "title_one": "1 edit to apply",
    "title_other": "{{count}} edits to apply",
    "show": "Show edits",
    "hide": "Hide edits",
    "accept": "Accept edits",
    "reject": "Reject",
    "reasonPlaceholder": "What should change? (optional)",
    "confirmReject": "Reject edits",
    "back": "Back",
    "accepted_one": "Accepted · 1 edit",
    "accepted_other": "Accepted · {{count}} edits",
    "failed_one": "1 failed",
    "failed_other": "{{count}} failed",
    "rejected": "Rejected. Nothing changed."
  },
  "action": {
    "apply": "Apply to sheet",
    "discard": "Discard",
    "applyAll": "Apply all",
    "discardAll": "Discard all",
    "applying": "Applying…",
    "applied": "Applied",
    "undo": "Undo",
    "reverted": "↺ Reverted. The previous content is back.",
    "discarded": "Discarded. Nothing changed.",
    "failed": "Failed",
    "show": "Show in Excel",
    "destructiveWarning": "This action cannot be undone by the assistant.",
    "cells_one": "{{count}} cell",
    "cells_other": "{{count}} cells",
    "oneSheet": "1 sheet",
    "oneChart": "1 chart",
    "oneTable": "1 table",
    "oneName": "1 name",
    "done": "done",
    "overwriteAck": "Overwrite {{count}} non-empty cells ({{sample}})",
    "protectedSheet": "Protected sheet — this write is always confirmed.",
    "converged": "converged",
    "newModel": "new model"
  },
  "question": {
    "title": "Sculpt needs to know",
    "send": "Send answers",
    "other": "Other…",
    "otherPlaceholder": "Your answer",
    "answerPlaceholder": "Your answer",
    "suggested": "Recommended",
    "leftToSculpt": "left to Sculpt",
    "cancel": "Cancel",
    "cancelled": "Cancelled — nothing was done."
  },
  "batch": {
    "writing_one": "Writing 1 change",
    "writing_other": "Writing {{count}} changes · {{sheets}} sheets",
    "reading_one": "Reading 1 place",
    "reading_other": "Reading {{count}} places · {{sheets}} sheets",
    "doneWriting_one": "1 change written",
    "doneWriting_other": "{{count}} changes across {{sheets}} sheets",
    "doneReading_one": "1 place read",
    "doneReading_other": "{{count}} places across {{sheets}} sheets",
    "progress": "{{done}} / {{total}}",
    "calls_one": "1",
    "calls_other": "{{count}}",
    "collapse": "Collapse"
  },
  "plan": {
    "add": "Adding “{{name}}”",
    "edit": "Changing “{{name}}”",
    "delete": "Removing “{{name}}”",
    "modelledOn": "modelled on {{name}}",
    "asked": "You asked for “{{asked}}”: no object has that name, so this is for “{{name}}”, the closest one.",
    "consumers": "Formulas that change with it",
    "rewritten": "rewritten",
    "widened": "Excel widens its range",
    "where": "Where",
    "rows_one": "1 row at {{at}}",
    "rows_other": "{{count}} rows at {{at}}",
    "cols_one": "1 column at {{at}}",
    "cols_other": "{{count}} columns at {{at}}",
    "rowsBand_one": "row {{first}}",
    "rowsBand_other": "rows {{first}}–{{last}}",
    "colsBand_one": "column {{first}}",
    "colsBand_other": "columns {{first}}–{{last}}",
    "notExtended": "Not extended",
    "notExtendedHint": "Adding a term to these would compute and mean nothing — they are yours to judge.",
    "byHand": "Still says “{{name}}” — remove by hand",
    "proposed": "Proposal: nothing was written. Switch to Ask or Auto to apply it.",
    "showFormula": "Show the formula"
  },
  "history": {
    "title": "History",
    "back": "Back to chat",
    "search": "Search chats",
    "opening": "Opening the chat",
    "empty": "No conversation yet for this workbook.",
    "noMatch": "No chat matches your search.",
    "untitled": "Untitled conversation",
    "delete": "Delete",
    "deleteConfirm": "Delete this conversation?",
    "rename": "Rename",
    "renamePrompt": "New title",
    "save": "Save",
    "cancel": "Cancel",
    "confirmDelete": "Delete",
    "actionFailed": "That didn't work. Please try again.",
    "groups": {
      "today": "Today",
      "yesterday": "Yesterday",
      "lastWeek": "Last week",
      "earlier": "Earlier"
    },
    "thisWorkbook": "This workbook",
    "all": "All my conversations",
    "ancestor": "Earlier version · {{name}}",
    "readOnly": "read-only",
    "noWorkbook": "no workbook",
    "emptyAll": "No conversation yet.",
    "resumed": "resumed"
  },
  "agents": {
    "main": "main",
    "discovery": "discovery",
    "builder": "builder",
    "formatting": "formatting",
    "charts": "charts",
    "verifier": "verifier"
  },
  "discovery": {
    "title": "How did you hear about us?",
    "subtitle": "This question is optional. Your answer helps us know where to make Sculpt known.",
    "continue": "Continue",
    "skip": "Skip",
    "sources": {
      "linkedin": "LinkedIn",
      "google": "Google",
      "youtube": "YouTube",
      "word_of_mouth": "Word of mouth",
      "other": "Other"
    }
  },
  "access": {
    "title": "Sculpt Agent is not enabled for your account yet.",
    "message": "Ask your Peerception contact to enable the assistant for you, then check again.",
    "signedInAs": "Signed in as",
    "checkAgain": "Check again",
    "checking": "Checking…",
    "stillDenied": "Still not enabled. Access is granted by Peerception; nothing to do on your side.",
    "signOut": "Sign out",
    "reasons": {
      "email_unverified": {
        "title": "Confirm your email address to start.",
        "message": "We sent a link to your address when you signed up. Open it, then check again here.",
        "stillDenied": "Still not confirmed. Open the link in the email, or ask for a new one below."
      },
      "organization_suspended": {
        "title": "Your organization's access is suspended.",
        "message": "Ask your Peerception contact to restore it, then check again.",
        "stillDenied": "Still suspended. Access is restored by Peerception; nothing to do on your side."
      },
      "no_organization": {
        "title": "Your account has no organization yet.",
        "message": "Ask your Peerception contact, then check again.",
        "stillDenied": "Still no organization. Peerception sets this up; nothing to do on your side."
      },
      "no_subscription": {
        "title": "Your organization has no subscription.",
        "message": "An owner or admin of your organization chooses an offer in your account, then check again here.",
        "stillDenied": "Still no subscription. A new one starts once its order is paid."
      },
      "free_full": {
        "title": "Every place on the Free offer is taken for now.",
        "message": "Choose a paid offer in your account, or join the waiting list there, then check again here.",
        "stillDenied": "Still no subscription. A paid offer starts once its order is paid; a Free place, once one opens."
      },
      "trial_ended": {
        "title": "Your trial has ended.",
        "message": "Choose an offer in your account to keep using Sculpt. Your workbooks and conversations are kept.",
        "stillDenied": "Still no active offer. It starts as soon as its order is paid."
      },
      "payment_overdue": {
        "title": "Your subscription's renewal is unpaid.",
        "message": "The assistant is paused until the renewal is paid. The payment details are in your account.",
        "stillDenied": "Still unpaid. It reopens as soon as the payment is recorded."
      }
    },
    "resend": "Resend the email",
    "resending": "Sending…",
    "resent": "Sent. Check your inbox (and the spam folder).",
    "resendFailed": "The email could not be sent. Try again in a minute.",
    "openPortal": "Open my account",
    "openBilling": "Open billing in my account"
  },
  "protect": {
    "title": "Protected sheets",
    "help": "The agent never writes to a ticked sheet without asking, in any mode.",
    "noWorkbook": "Send a first message so this workbook gets an identity.",
    "save": "Save",
    "cancel": "Cancel"
  },
  "converge": {
    "none": "No circular block in this workbook's map.",
    "running": "Converging…",
    "converged": "{{block}}: converged in {{count}} iterations.",
    "diverged": "{{block}}: diverged — pasted values restored.",
    "capped": "{{block}}: not converged after {{count}} iterations.",
    "failed": "{{block}}: {{error}}",
    "iterativeOn": "Excel iterative calculation is enabled — disable it (File → Options → Formulas).",
    "dismiss": "Dismiss"
  },
  "feedback": {
    "question": "How is this going?",
    "up": "Helpful",
    "down": "Not helpful",
    "whatWrong": "What went wrong?",
    "whatWorked": "What worked well?",
    "commentPlaceholder": "Anything else? (optional)",
    "comment": "Add a comment",
    "editComment": "Edit your comment",
    "remove": "Remove rating",
    "pickLabel": "Pick a label to send.",
    "back": "Back",
    "send": "Send",
    "cancel": "Cancel",
    "dismiss": "Dismiss",
    "thanks": "Thanks — noted.",
    "failed": "Could not send your feedback.",
    "tag": {
      "wrong_formula": "Wrong formula",
      "misunderstood": "Misunderstood me",
      "too_slow": "Too slow",
      "broke_sheet": "Broke my sheet",
      "wrong_output": "Wrong result",
      "too_many_steps": "Too many steps",
      "accurate": "Accurate",
      "understood": "Understood me",
      "fast": "Fast",
      "saved_time": "Saved me time",
      "other": "Something else"
    }
  },
  "report": {
    "title": "Report this conversation",
    "intro": "A person on the Sculpt team will read this conversation to look into it.",
    "reason": "Why are you reporting it?",
    "reasons": {
      "wrong_result": "Wrong numbers or formulas",
      "damaged_workbook": "Damaged my workbook",
      "inappropriate": "Inappropriate answer",
      "data_concern": "Data or security concern",
      "other": "Something else"
    },
    "commentPlaceholder": "What happened? (optional)",
    "cancel": "Cancel",
    "send": "Send report",
    "sending": "Sending…",
    "close": "Close",
    "sent": "Report sent — our team will look into it.",
    "failed": "Could not send the report. Try again.",
    "tooMany": "You have sent many reports today. Try again tomorrow."
  },
  "index": {
    "failed": "Indexing failed: {{error}}",
    "composerLocked": "Indexing your workbook… the chat opens when the index is ready.",
    "composerFailed": "The workbook could not be indexed. Retry to start again.",
    "composerUnderstanding": "Understanding your workbook… the chat opens when the sheets are understood.",
    "reading": "Reading your workbook…",
    "understandingRun": "Understanding your workbook…",
    "updating": "Picking up your changes…",
    "understandLater": "Your workbook will be read again with your next message.",
    "retry": "Retry",
    "reread": "Read the workbook again",
    "dot": {
      "ready": "Workbook up to date",
      "busy": "Updating the workbook…",
      "warn": "The workbook will be read again with your next message",
      "failed": "The workbook could not be indexed"
    }
  },
  "intro": {
    "title": "Let Sculpt read your model first",
    "why": "Sculpt reads the whole workbook once and builds a map of it — the sheets, how the calculation flows. That map is what lets it answer about your model and place a change where it belongs, instead of guessing cell by cell.",
    "pointUpload": "Your sheets are sent to Sculpt Agent to build the map.",
    "pointOnce": "It happens once per file. Later sessions open straight into the chat, and only what you changed is read again.",
    "timeUnder1": "This workbook should take less than a minute.",
    "timeAbout1": "This workbook should take about a minute.",
    "timeRange": "This workbook should take {{low}} to {{high}} minutes.",
    "sheets_one": "1 sheet",
    "sheets_other": "{{count}} sheets",
    "modelTitle": "Choose the model",
    "modelWhy": "It decides where your workbook is sent to be read, and your conversations run on it. You can change it later in the chat.",
    "start": "Read my workbook",
    "demoLead": "You can also try Sculpt on",
    "demoLink": "our demo model →",
    "looking": "Looking at your workbook…",
    "cellEdit": "Excel is busy while you edit a cell. Press Enter or Esc to finish, and Sculpt opens right after.",
    "retry": "Try again",
    "starting": "Starting…",
    "progress": "{{done}} of {{total}}",
    "patience": "Excel may run slower while this is in progress, so it is best to avoid heavy work in the workbook. The chat opens as soon as it is done.",
    "phase": {
      "probing": "Looking at your workbook…",
      "cell_edit": "Waiting for the cell edit to finish",
      "capturing": "Reading your sheets",
      "committing": "Building the map",
      "understanding": "Understanding your model",
      "idle": "Starting…",
      "ready": "Ready",
      "needs_consent": "Ready when you are",
      "failed": "Indexing failed"
    }
  },
  "identity": {
    "title": "Which workbook is this?",
    "titleShared": "This file was first read by someone else",
    "changed": {
      "name": "Last time, this file was called “{{name}}”. It has been renamed.",
      "place": "This is “{{name}}”, opened from another location.",
      "both": "Last time, this file was “{{name}}”. It has been renamed and sits in another location."
    },
    "whyShared": "“{{name}}” was first read by another user. Are you working on their file, or on your own copy?",
    "same": "Same file",
    "sameHint": "It was moved or renamed. Its conversations carry on here.",
    "fork": "New version of “{{name}}”",
    "forkHint": "This file will diverge from the original. It keeps the history of the conversations tied to the original.",
    "other": "Another workbook",
    "otherHint": "Nothing is carried over: Sculpt reads it from scratch.",
    "resume": "Resume “{{name}}”",
    "resumeHint": "New version of “{{parent}}”, created {{date}}.",
    "shared": "Shared with me",
    "sharedHint": "The same file as its owner’s. Nothing is written into it.",
    "ownCopy": "My own copy",
    "ownCopyHint": "A workbook of your own, read from scratch.",
    "ownCopyVersion": "My own copy — new version",
    "ownCopyOther": "My own copy — another workbook",
    "lostId": "“{{name}}” was read at this place before, but this file’s sheets are not the same.",
    "lostIdResumeHint": "It is “{{name}}” after all: its conversations carry on here, and every sheet is read again.",
    "dismiss": "Not now: treat it as the same file for this session",
    "dismissLostId": "Not now: read it as a new workbook for this session",
    "failed": "The answer could not be saved: {{error}}"
  },
  "thread": {
    "readOnly": "This conversation belongs to “{{name}}”. It is read-only in this workbook.",
    "readOnlyNoFile": "This conversation is not tied to this workbook. It is read-only here.",
    "continueHere": "Continue in a new conversation",
    "continuing": "Summarising the conversation…",
    "continueFailed": "The conversation could not be continued: {{error}}",
    "resumedFrom": "Resumed from “{{title}}” · {{file}}",
    "composerReadOnly": "Read-only in this workbook: continue in a new conversation to write."
  },
  "account": {
    "menu": "Account",
    "usage": "Plan & usage",
    "billing": "Billing",
    "invoices": "Invoices",
    "organization": "Organization",
    "profile": "Profile"
  },
  "model": {
    "label": "Model",
    "hint": "{{model}}, hosted by {{host}}",
    "hostedBy": "hosted by {{host}}",
    "dataIn": "data in",
    "price1": "Low price",
    "price2": "High price",
    "madeBy": "model by {{maker}}",
    "startsNew": "This conversation keeps its model. Picking another one starts a new conversation.",
    "refused": "Your organization no longer allows the model of this conversation. Start a new conversation to continue."
  },
  "flag": {
    "US": "United States",
    "FR": "France",
    "EU": "European Union"
  },
  "audit": {
    "title": "Structural audit",
    "outputs": "Key outputs used for the severity: {{outputs}}",
    "noOutputs": "No key output found: severity follows what each finding feeds",
    "iterationOff": "iterative calculation off",
    "hidden": "Hidden",
    "none": "No finding here.",
    "error": "Error",
    "construction": "Construction",
    "reaches": "reaches {{output}}",
    "feedsNothing": "feeds nothing",
    "writeSheet": "Write an audit sheet",
    "sheetWriting": "Writing…",
    "sheetDone": "Audit Findings sheet written",
    "sheetFailed": "Writing failed.",
    "fix": "Fix",
    "fixMessage": "Fix {{id}} ({{title}}): apply the recommended fix.",
    "fixRequested": "Fix requested",
    "fixed": "Fixed",
    "fixedCount_one": "{{count}} fixed",
    "fixedCount_other": "{{count}} fixed",
    "sheetUpdated": "Audit Findings sheet updated"
  },
  "drivers": {
    "title": "What drives this number",
    "counts": "{{business}} business assumptions · {{timing}} timing · {{pasted}} pasted",
    "loop": "The number sits in a circular reference: the loop's own assumptions are among its drivers.",
    "business": "Business assumptions, by concept",
    "none": "No business assumption upstream.",
    "inFormulas": "Numbers typed in formulas",
    "pasted": "Pasted values",
    "pastedNote": "They move only when pasted again, not when the assumptions change.",
    "timing": "Timing ({{count}})",
    "timingRolled": "{{count}} assumptions",
    "externals": "From other workbooks: {{refs}}",
    "unresolved": "Not followed (INDIRECT): {{cells}} — drivers may be missing",
    "calculations": "Through {{count}} calculations: {{sheets}}",
    "select": "select",
    "share": "{{cells}} of {{total}} cells",
    "show": "Show the detail: {{drivers}} drivers · {{calculations}} calculations",
    "tables": "Lookup tables",
    "tablesNote": "Read only by VLOOKUP, INDEX, MATCH, SUMIFS…: the table drives the number through the entry the lookup finds.",
    "entries": "{{count}} entries",
    "more": "+ {{count}} more — ask for this concept to list them",
    "dormant": "No effect in {{period}}",
    "dormantAny": "No effect in this period",
    "dormantNote": "The number reads them, but they do not move it in this period. Change what is said below and they count again.",
    "dormantCount": "{{count}} without effect in this period"
  },
  "metrics": {
    "title": "Key dates and indicators",
    "show": "Show the detail: {{indicators}} indicators · {{dates}} key dates",
    "family": {
      "dates": "Key dates",
      "cover": "Debt cover",
      "returns": "Returns",
      "financing": "Financing"
    },
    "minAvg": "min {{min}} · avg {{avg}}",
    "zero": "0 in every period",
    "periods": "{{count}} periods, {{first}} → {{last}}",
    "computed": "minimum and average computed by Sculpt: the file has no MIN / AVERAGE cell",
    "also": "also at",
    "more": "+ {{count}} more",
    "thresholds": "Thresholds",
    "thresholdsNote": "Targets, covenants and sizing inputs — not the indicators.",
    "selectors": "Scenario and sensitivity",
    "missing": "Not found in the file: {{names}}"
  },
  "modelMap": {
    "title": "How the model is built",
    "show": "Show the map: {{chains}} chains · {{families}} families of assumptions",
    "counts": "{{concepts}} concepts · {{links}} links between them",
    "chains": "Chains to the key outputs",
    "chainsNote": "What feeds each output, the heaviest first — flags, calendars and checks left out.",
    "lines": "{{count}} lines",
    "inputs": "inputs reached: {{families}}",
    "inventory": "Where the assumptions sit",
    "more": "+ {{count}} more",
    "family": {
      "reserve": "Reserves",
      "valuation": "Valuation",
      "statements": "Statements",
      "debt": "Debt",
      "equity": "Equity",
      "tax": "Tax",
      "revenue": "Revenue",
      "opex": "Opex",
      "capex": "Capex",
      "quantity": "Quantities",
      "indexation": "Indexation",
      "asset": "Asset",
      "timing": "Timing",
      "other": "Other"
    }
  },
  "terms": {
    "title": "Term sheet against the model",
    "show": "Show every term: {{gaps}} gaps · {{total}} terms",
    "status": {
      "gap": "Gaps",
      "ambiguous": "Several candidates",
      "to judge": "To judge",
      "not in the model": "Not in the model",
      "matches": "Matches",
      "located": "Where the model holds them"
    },
    "document": "document",
    "gap": "gap {{gap}}",
    "computed": "computed by the model",
    "instead": "In its place in the model:",
    "notStated": "Not stated by the document: {{names}}",
    "milestones": "Milestones",
    "writeSheet": "Write the gaps to a sheet",
    "sheetWriting": "Writing…",
    "sheetDone": "Term Sheet Gaps sheet written",
    "sheetFailed": "Writing failed."
  },
  "manual": {
    "title": "Writing by hand",
    "sheets": "Only on {{sheets}}",
    "undo": "Can be taken back as a whole"
  }
}
